import { useMemo } from 'react';
import { useApiQuery } from './useApiQuery';
import { partnersApi } from '@/api/partners';
import type { Partner } from '@/api/partners';
import mockData from '@/data/mock-data.json';

interface UsePartnerOptions {
  enabled?: boolean;
}

export const usePartner = (id: string | undefined, options: UsePartnerOptions = {}) => {
  const { enabled = true } = options;

  const mockPartner = useMemo<Partner | undefined>(
    () => (mockData.partners as Partner[]).find((p) => p.id === id),
    [id],
  );

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<Partner>(
    {
      queryFn: () => partnersApi.get(id as string),
      mockData: mockPartner,
      enabled: enabled && Boolean(id),
    },
    [id],
  );

  return { partner: data, isLoading, error, isUsingMockData, reload };
};
